import {
  IFacialControllerConfigUpdateParams,
  IFacialControllerCreateProps,
  IFacialControllerFilterProps,
  IFacialControllerGetAllParams,
  IFacialControllerProps,
  IFacialControllerSimpleProps,
  IFacialControllerUpdateParams,
} from './types';
import { api } from '../../../DefaultService';
import { ISelectionOption } from 'services/types';

const ENDPOINT = 'v1/devices/cameras/facialController';
const ENDPOINTCONTROLID = 'v1/devices/controlId';

export const createFacialControllerAsync = async (
  data: IFacialControllerCreateProps,
): Promise<IFacialControllerProps> => {
  if (data.brand == 'CONTROLID') {
    return await api
      .post(ENDPOINTCONTROLID, data)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  } else {
    return await api
      .post(ENDPOINT, data)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  }
};

export const getFacialControllerByIdAsync = async (
  id: number,
): Promise<IFacialControllerProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllFacialControllerByLicenseAsync = async ({
  pagination,
  filter,
}: IFacialControllerGetAllParams): Promise<IFacialControllerSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllFacialControllerCountByLicenseAsync = async (
  filter?: IFacialControllerFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateFacialControllerAsync = async ({
  id,
  data,
}: IFacialControllerUpdateParams): Promise<IFacialControllerProps> => {
  if (data.brand == 'CONTROLID') {
    return await api
      .put(`${ENDPOINTCONTROLID}/${id}`, data)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  } else {
    return await api
      .put(`${ENDPOINT}/${id}`, data)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  }
};
export const updateConfigFacialControllerAsync = async ({
  id,
  data,
}: IFacialControllerConfigUpdateParams): Promise<void> => {
  await api.put(`${ENDPOINT}/${id}/config`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const deleteFacialControllerAsync = async (
  id: number,
): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getAllControllersForSelectionAsync = async (): Promise<ISelectionOption[]> => {
  try {
    const response = await api.get(`${ENDPOINT}/selection`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar controladores faciais.');
  }
};